const RouteURLs = {
  // misc
  LANDING: "/landing",
  LANDING_TEMPLATE: "/landing/:name",
  TENANT_CALCULATOR: "/tenant-calculator",
  CROWDFUNDING: "/crowdfunding",
  SUPPORT: "/support",
  NOT_FOUND: "/not-found",
  WHAT_IS_SOOK: "what-is-sook",
  EVENTS: "events",
  // content template
  BASIC_TEMPLATE: "/content/:name",
  // experience
  EXPERIENCE: "/sook-experience",
  // landlords
  LANDLORD_DASHBOARD: "/landlords/dashboard",
  LANDLORD_BOOKINGS: "/landlords/bookings",
  // blog
  VIEW_BLOG_DETAIL: "/blog/:code",
  VIEW_BLOG_REPORT: "/blog/:code/report",
  // legal
  COOKIES: "/legal/cookies",
  // spaces
  VIEW_SPACE: "/spaces/:slug",
  SPACE_LANDING: "/spaces/:slug/landing",
  BOOK_SPACE: "/spaces/:slug/book",
  // account
  LOGIN: "/account/login",
  REGISTER: "/account/register",
  REQUEST_PASSWORD_RESET: "/account/password/request-reset",
  RESET_PASSWORD: "/account/password/reset/:token",
  // dashboard
  DASHBOARD: "/dashboard",
  // designs
  DESIGN_LIST: "/designs",
  NEW_DESIGN: "/designs?new",
  EDIT_DESIGN_SCREEN_GROUP:
    "/designs/:designCode/screen-groups/:screenGroupCode/edit/:mediaType/:screenWidth?/:screenHeight?",
  PREVIEW_DESIGN: "/designs/:designCode/preview",
  // bookings
  BOOKINGS_LIST: "/bookings",
  CREATE_BOOKING: "/bookings/create",
  CREATE_BOOKING_TIME: "/bookings/create/time",
  CREATE_BOOKING_ADDONS: "/bookings/create/add-ons",
  CREATE_BOOKING_CHECK_OUT: "/bookings/create/check-out",
  CREATE_BOOKING_SUCCESS: "/bookings/:code/success",
  EDIT_BOOKING: "/bookings/:code",
  EDIT_BOOKING_TIME: "/bookings/:code/time",
  EDIT_BOOKING_ADDONS: "/bookings/:code/add-ons",
  EDIT_BOOKING_CHECK_OUT: "/bookings/:code/check-out",
  EDIT_BOOKING_SUCCESS: "/bookings/:code/success",
  REBOOK: "/bookings/:code/rebook",
  BULK_DOWNLOAD_OCCUPATIONAL_LICENSE: "/bookings/occupational-license/download",
  // analytics
  VIEW_ANALYTICS: "/analytics",
  // discounts
  VIEW_DISCOUNT: "/discounts/:code",
  // events
  EVENTS_LIST: "/events",
  // confirmation
  THANK_YOU_LANDING_PAGE: "/enquiry/thank-you-lp",
  THANK_YOU_BOOKING_BAR: "/enquiry/thank-you-booking-bar",
};

export default RouteURLs;
